import React, { useState } from 'react';
import { ArrowSquareOut, Copy, Check } from '@phosphor-icons/react';
import { useParams } from 'react-router-dom';

import { trackShareCopyLink, trackShareOpenLink } from '../../analytics';

import useSampleProjectData from '../../hooks/useSampleProjectData';

import { handleCopy } from '../../utils';

import { Button } from '../general';

interface Props {
  type?: string;
  link: string;
  btnOnly?: boolean;
  handleOpenTrack?: () => void;
  handleCopyTrack?: () => void;
}

const LinkBox: React.FC<Props> = (props) => {
  const { eventId = '' } = useParams();

  const {
    type,
    link,
    btnOnly,
    handleOpenTrack = () => {},
    handleCopyTrack = () => {},
  } = props;

  const [isCopied, setIsCopied] = useState(false);

  const { isSample } = useSampleProjectData(eventId);

  const onClickOpenLink = () => {
    window.open(link, '_blank');

    if (type) trackShareOpenLink(type, isSample);
    else handleOpenTrack();
  };

  const onClickCopy = () => {
    handleCopy(link, setIsCopied);

    if (type) trackShareCopyLink(type, isSample);
    else handleCopyTrack();
  };

  const buttons = (
    <div className="flex items-center justify-center">
      <Button
        variant="square"
        colour="transparent-black"
        className="text-[1.25rem]"
        onClick={onClickOpenLink}
      >
        <ArrowSquareOut />
      </Button>

      <Button
        variant="square"
        colour="transparent-black"
        className="text-[1.25rem]"
        onClick={() => onClickCopy()}
      >
        {isCopied ? <Check /> : <Copy />}
      </Button>
    </div>
  );

  if (btnOnly) return buttons;

  return (
    <div className="relative w-full flex items-center justify-between px-3 py-1 gap-3 text-black border border-black border-solid rounded-md">
      <div className="w-[85%] whitespace-nowrap overflow-hidden text-ellipsis text-sm">
        {link}
      </div>

      {buttons}
    </div>
  );
};

export default LinkBox;
